import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";

@Component({
  selector: "app-inform-dialog",
  templateUrl: "./inform-dialog.component.html",
  styleUrls: ["./inform-dialog.component.scss"],
})
export class InformDialogComponent implements OnInit {
  form: FormGroup;

  title: string;
  message: string;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<InformDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit() {}
}
